import React from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import useStripe from '../../Hooks/useStripe';
import OverlayLoading from '../../../../Components/OverlayLoading';
import LinkButton from '../../../../Components/Button/LinkButton';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	workplaceId: string;
}

const StripeDashboardButton: React.FC<Props> = ({ workplaceId }) => {
	const { isStripeConnectConfigured, isLoading } = useStripe();
	const { socketUrl } = useAppContext();

	if (isStripeConnectConfigured) {
		return (
			<>
				{isLoading && <OverlayLoading />}
				<LinkButton
					title='base.stipePaymentGateway'
					theme={Theme.BLUE}
					displayAsButton
					href={`${socketUrl}/payments/stripe/account/dashboard/${workplaceId}`}
					fitContent
				/>
			</>
		);
	}

	return <></>;
};

export default StripeDashboardButton;
